export class QuestionBase {
    controlType;
    key;
    type;
    value;
    placeholder;
    label;
    options;
    config;
    validator;
    required;
    events;
    data;
    width;
    error;
    icon;
    regex;

    constructor(args) {
        this.icon = args.icon;
        this.controlType = args.controlType || 'textbox';
        this.key = args.key || null;
        this.type = args.type || 'text';
        this.value = args.value === undefined ? null : args.value;
        this.placeholder = args.placeholder || null;
        this.label = args.label || null;

        this.error = args.error || null;
        this.regex = args.regex;
        this.width = args.width || 100;
        this.options = args.options || null;
        this.data = args.data || {};
        this.config = args.config || {};
        this.validator = args.validator || this.validatorFn.bind(this);
        this.required = args.required || false;
        this.events = args.events || {};
    }

    validatorFn(value, question) {
        if(!this.required) return true;

        return value && value.length !== 0 && (!this.regex || this.regex.test(value));
    }
}
